import logo from './logo.svg';
import './App.css';
import ContactForm from './Contact';

import React, { useState } from 'react';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="h1">Manhasset Cars and Coffee</h1>
        <h2 className="h2">Drivers Welcome</h2>
        <iframe
          src="https://bobtrieste.smugmug.com/frame/slideshow?key=7LfVQP&speed=3&transition=fade&autoStart=1&captions=0&navigation=0&playButton=0&randomize=0&transitionSpeed=2"
          width="900" height="700" frameborder="0" ></iframe>



        <p style={{ textAlign: 'center', fontSize: '32px' }}>Manhasset Cars and Coffee was started by area locals and friends who enjoy cars of all makes and models. We are an informal gathering of automotive enthusiasts who come together to celebrate some awesome machines and
          the people who love them. We celebrate the automotive spirit of all marques and vintages, old and new, along with some good conversation
          over coffee.</p>


        <p style={{ textAlign: 'center', fontSize: '32px', color: 'yellow' }}>
          <u>Join our mailing list below. Drivers Welcome!</u></p>


        <div>
          <ContactForm />
        </div>

        <div hidden id="success" class="text-sm font-bold text-white bg-blue-500" role="alert">Form submited successfully. Thank you! Check spam folder for welcome e-mail.</div>

        <p> <img src="MCClogo.jpg" alt="MCClogo" /></p>
        <span>
          <a
            className="App-link"
            href="https://www.instagram.com/manhassetcarsandcoffee/"
            target="_blank"
            rel="noopener noreferrer"
          > <img src="Insta.jpg" alt="Insta" /></a>

          <a
            className="App-link"
            href="https://bobtrieste.smugmug.com/Cars/Summer2020/"
            target="_blank"
            rel="noopener noreferrer"
          > <img src="SmugMug.jpg" alt="SmugMug" /></a>
          <a
            className="App-link"
            href="https://vimeo.com/showcase/5083448"
            target="_blank"
            rel="noopener noreferrer"
          > <img src="Vimeo.jpg" alt="Vimeo" /></a>
          <a
            className="App-link"
            href="https://www.facebook.com/groups/801287630707536"
            target="_blank"
            rel="noopener noreferrer"
          > <img src="Facebook.jpg" alt="Facebook" /></a>
        </span>
      </header>
    </div >
  );
}

export default App;

